import React, { Component } from 'react'
import Swal from "sweetalert2";
import "../css/general-style.css"
import '../css/table-responsive.css'
import "../css/pickingSystem-style.css"
import { AiOutlineComment } from "react-icons/ai"
import { FiTrash, FiSave } from "react-icons/fi";
import { getValueCookie } from '../services/cookieService'
import { create_Delete_Update_Information, getInformationWithData, saveJsonData } from '../services/CABE'
import { DateFormatMAS90, FormatQueryReturnDateForReport, getActualDateUTC, getDateYearMonthDayDash } from '../functions/dateFormat';
import LoadingWindow from '../components/LoadingWindow';
import FinishedSalesOrderList  from '../components/FinishedSalesOrderList ';
import { confirmCloseAlert } from '../functions/alerts';
import { getPrintHeaderCompany } from '../functions/companyInformation';
import { OrderPDF } from '../components/OrderPDF';
import { pricesFormat } from '../functions/pricesFormat';
import { DecimalPart, getPriceMargin, getPurePriceMargin, MobileDisp, NumberFormat, OrderArray, validateNumbersForQuantitys } from '../functions/generalFunctions';
import SearchUPC from '../components/SearchUPC';
import Catalogue2 from '../components/Catalogue2.0/Catalogue2.0';
import SingleOrderPicking from '../components/SingleOrderPicking'
import { DownloadOrderPDF } from '../components/DownloadOrderPDF';
import { Menu } from "../components/Menu/Menu";



export default class SalesPickingSystem extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }

    state = {
        disable: false,
        isInputFocused: false,
        ConfirmSave: 0,
        ProductList: [],
        ProductsForAltitude: [],
        Products: [],
        SalesOrder: {
            Customer: {
                AddressLine1: '',
                City: '',
                CustomerName: '',
                CustomerNo: '',
                EmailAddress: '',
                PriceLevel: undefined,
                SalespersonNo: '',
                State: '',
                TelephoneNo: '',
                ZipCode: '',
                uniqueTrack: '',
            },
            NoOrder: '',
            Type: 'S',
            TotalQuantityOrdered: 0,
            TotalCost: 0,
            TotalWeight: 0,
            Date: getDateYearMonthDayDash(),
            Warehouse: '000',
            Packing: null,
            WeightOption: null,
            MAS90Status: 0,
            TotalLines: 0,
            Duplicate: false,
            status: null,
        },
        companyPrintHeader: getPrintHeaderCompany(),
        showModal1: false,
        confirmMargin: false,
        NotZeroUnitPrice: true,
        enableEdit: false,
        isNotNewSO: true,
        newSalesOrder: false,
        currentStep: 1, // Wizard Step
        formData: {}, // Wizard validation 
    }

    setupBeforeUnloadListener = () => {
        if (this.state.Products.length > 0) {
            window.addEventListener("beforeunload", (ev) => {
                ev.preventDefault();
                ev.returnValue = '';
                return this.doSomethingBeforeUnload();
            });
        }
    };

    async getNewCorrelativeSalesOrder() {
        this.clearSalesOrder()
        const data = {
            type: 'SalesOrder',
            idCompany: getValueCookie('CompanyId')
        }
        const result = await getInformationWithData('/sales/get/correlative', data)
        if (result.status.code === 1) {
            const temporal = this.state.SalesOrder
            temporal.NoOrder = (getValueCookie('CompanyId') === '6' ? 'AL' : 'PM') + result.data[0].correlative
            this.setState({ SalesOrder: temporal })
        }
    }

    valueRadioButton = async e => {
        let stat = e.target.value
        const temporal = this.state.SalesOrder
        temporal.Type = stat
        this.setState({ SalesOrder: temporal })
    }

    calculateTotals() {
        let totalQuantity = 0
        let totalCost = 0
        let totalWeight = 0
        let totalPrice = 0
        const temporal = this.state.Products
        const temporal2 = this.state.SalesOrder

        for (const item of temporal) {

            totalPrice += Number(item.LastTotalUnitCost) * Number(item.quantityOrdered)
            totalQuantity += Number(item.quantityOrdered)
            totalCost += Number(item.totalCost)
            totalWeight += Number(item.quantityOrdered) * Number(item.ShipWeight)
        }

        temporal2.TotalQuantityOrdered = totalQuantity
        temporal2.TotalCost = totalCost
        temporal2.TotalWeight = totalWeight
        temporal2.Customer.uniqueTrack = getPriceMargin(totalCost, totalPrice, temporal2.Customer.PriceLevel)
        this.setState({ SalesOrder: temporal2 })
        this.AutoSave()
    }
    
    async getItemList() {
        const data = {
            idcompany: "3"
        }
        try {
            let response = await getInformationWithData('/Items/get', data);
            this.setState({ProductList: response.data})
        } catch (error) {
            console.log(error)
        }
    }
    
    setAltPrice(item){
        let altitudePrice = item.LastTotalUnitCost / 0.95;
        altitudePrice = altitudePrice / (1 - (item.MarkUp / 100));
        return altitudePrice;
    }

    checkMinPrice(temporal, newValue) {
        const productList = this.state.ProductList;
        const originalItem = productList.find(item => item.itemCode === temporal.itemCode);
        const newPrice = Number(newValue.target.value);
        const n1Price = originalItem.UnitPrice

        if(newPrice < n1Price) {
            let altitudePrice = this.setAltPrice(originalItem);

            if(altitudePrice < n1Price) {
                altitudePrice = n1Price;
            }

            const totalCost = temporal.quantityOrdered * altitudePrice;

            this.setState((prevState) => ({
                Products: prevState.Products.map((item) => 
                    item.itemCode === temporal.itemCode
                    ? { ...item, UnitPrice: Number(altitudePrice.toFixed(2)), totalCost: totalCost}
                    : item
                )
            }))
            alert(`The lower price for this product is $${ NumberFormat(pricesFormat(n1Price)) }`)
            return false
        }
        return true
    }

    onTargetChange(e, product) {
        let newPrice = e.target.value;
        this.setState((prevstate) => {
            const updatedProducts = prevstate.Products.map((item) => {
                if(item.itemCode === product.itemCode) {
                    return { ...item, UnitPrice: newPrice };
                }
                return item
            });
            return { Products: updatedProducts }
        })
    }

    onTarget = async (e, item) => {
        const temporal = this.state.Products
        const ident = e.target.id.split('_')
        const index = temporal.indexOf(item)

        if (index !== -1) {
            if (ident[0] === "quantityOrderedSalesOrder") {
                    let quant = Number(e.target.value)

                    if (!validateNumbersForQuantitys(quant)) {
                        let parteDecimal = 1 - DecimalPart(quant)
                        quant += parteDecimal
                        document.getElementById(e.target.id).value = quant
                    }

                    temporal[index].quantityOrdered = Number(quant)
                    temporal[index].totalCost = (Number(quant) * Number(temporal[index].UnitPrice))
                    this.setState({ Products: temporal, ConfirmSave: 0 })
                    this.calculateTotals()
            } else if (ident[0] === "unitPriceSalesOrder") {
                temporal[index].UnitPrice = Number(e.target.value)
                temporal[index].totalCost = (Number(e.target.value) * Number(temporal[index].quantityOrdered))
                if (getValueCookie('CompanyId') === '6') {
                    // temporal[index].Comment = "BOX:" + getPriceMargin(temporal[index].UnitPrice, temporal[index].unitCost, this.state.SalesOrder.Customer.PriceLevel)
                    temporal[index].Comment = "BOX:" + this.state.SalesOrder.Customer.CustomerName
                    temporal[index].PureMargin = getPurePriceMargin(temporal[index].UnitPrice, temporal[index].unitCost)
                    
                }
                if (getValueCookie('CompanyId') === '6') {
                    if(this.checkMinPrice(temporal[index], e) && getValueCookie('TypeUser') !== '1') {
                        this.setState({ Products: temporal, ConfirmSave: 0 })
                        this.calculateTotals()
                    } else {
                    }
                } else {
                    this.setState({ Products: temporal, ConfirmSave: 0 })
                    this.calculateTotals()
                }
            }
        }
        await this.AutoSave()
        this.setState({ isInputFocused: false });
    }

    checkInputFocus = () => {
        this.setState({ isInputFocused: true });
    }

    clearSalesOrder() {
        const clear = {
            ConfirmSave: 0,
            confirmMargin: false,
            NotZeroUnitPrice: true,
            Customer: {
                AddressLine1: '',
                City: '',
                CustomerName: '',
                CustomerNo: '',
                EmailAddress: '',
                PriceLevel: undefined,
                SalespersonNo: '',
                State: '',
                TelephoneNo: '',
                ZipCode: '',
                uniqueTrack: '',
            },
            TotalLines: 0,
            NoOrder: '',
            Type: 'S',
            TotalQuantityOrdered: 0,
            TotalCost: 0,
            TotalWeight: 0,
            Date: getDateYearMonthDayDash(),
            Warehouse: '000',
            Packing: null,
            WeightOption: null,
            MAS90Status: 0,
            Duplicate: false,
        }
        this.setState({ SalesOrder: clear, Products: [], enableEdit: false })
        localStorage.removeItem('SalesOrderSave')
    }

    addComentary(item) {
        let comm = item.Comment
        Swal.fire({
            title: 'Product: ' + item.itemCode,
            html: `<div class='textAreaGeneral textAreaComment'>
                    <textarea id='comentOfSalesOrder' rows="10" cols="50">${comm}</textarea>
                   </div>
            `,
            backdrop: true,
            showCancelButton: true,
            confirmButtonText: 'Save Commentary',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                const temporal = this.state.Products
                const index = temporal.indexOf(item)
                if (index !== -1) {
                    const coment = Swal.getPopup().querySelector('#comentOfSalesOrder').value
                    temporal[index].Comment = coment
                    this.setState({ Products: temporal })
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        })
        this.AutoSave()
    }

    removeProduct(item) {
        let temporal = this.state.Products
        const index = temporal.indexOf(item)

        if (index !== -1) {
            temporal[index].quantityOrdered = 0
            temporal[index].totalCost = 0
            temporal[index].Visible = 0

            for (let a = 0; a < temporal.length; a++) {
                document.getElementById("quantityOrderedSalesOrder_" + a).value = temporal[a].quantityOrdered
                document.getElementById("unitPriceSalesOrder_" + a).value = temporal[a].UnitPrice
            }
            
            this.setState({ Products: temporal })
            this.calculateTotals()
        }
        this.AutoSave()
    }

    refreshInputs() {
        const temporal = this.state.Products
        for (let a = 0; a < temporal.length; a++) {
            document.getElementById("quantityOrderedSalesOrder_" + a).value = temporal[a].quantityOrdered
            document.getElementById("unitPriceSalesOrder_" + a).value = temporal[a].UnitPrice
        }
    }

    AsignLineSequence() {
        const head = this.state.SalesOrder
        if (getValueCookie('CompanyId') === '6') {
            const temporal = OrderArray(JSON.parse(JSON.stringify(this.state.Products)), 'IdCompany', true)

            let confirmMargin = false
            let NotZeroUnitPrice = true
            let count = 1
            let activeLines = 0
            for (const item of temporal) {
                item.LineSequence = count
                item.quantityShipped = 0
                count++
                if (!confirmMargin) {
                    confirmMargin = item.PureMargin > 20 ? false : true
                }
                if (item.UnitPrice <= 0 && item.Visible === 1) {
                    NotZeroUnitPrice = false
                }
                if (item.Visible !== 0) {
                    activeLines++
                }
            }

            head.TotalLines = activeLines
            this.setState({ confirmMargin: confirmMargin, NotZeroUnitPrice: NotZeroUnitPrice, SalesOrder: head })
            return temporal
        } else {
            const temporal = this.state.Products
            let NotZeroUnitPrice = true
            let count = 1
            let activeLines = 0
            for (const item of temporal) {
                item.LineSequence = count
                item.quantityShipped = 0
                count++
                if (item.UnitPrice <= 0 && item.Visible === 1) {
                    NotZeroUnitPrice = false
                }
                if (item.Visible !== 0) {
                    activeLines++
                }
            }
            head.TotalLines = activeLines
            this.setState({ NotZeroUnitPrice: NotZeroUnitPrice, SalesOrder: head })
            return temporal
        }
    }

    detailToPrint() {
        let items = []
        this.state.Products.forEach(element => {
            if (element.Visible === 1) {
                element.abbreviatedDesc = (element.completeDesc && element.completeDesc !== "null") ? element.completeDesc : element.abbreviatedDesc
                items.push(element)
            }
        });
        return items
    }

    async updateMayalandSO(altitudeSO) {
        let mayalandTemporal = altitudeSO;
        mayalandTemporal.idCompany = "3"
        mayalandTemporal.company = 'Mayaland Atlanta'
        mayalandTemporal.Customer.CustomerNo = '0016027';
        mayalandTemporal.Detail = this.updateAltitudePrices(mayalandTemporal.Detail);
        
        // const result = await create_Delete_Update_Information('/sales/set/order', mayalandTemporal)
        await create_Delete_Update_Information('/sales/set/order', mayalandTemporal)
    }

    updateAltitudePrices(productList) {
        productList.forEach(element => {
            const altitudePrice = element.LastTotalUnitCost / 0.95;
            element.UnitPrice = Number(altitudePrice.toFixed(2))
        });
        return productList;
    }

    async checkSalesOrderStatus(SONumber){
        const data = {
            SalespersonNo: getValueCookie('SalesPerson'),
            idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
        }
        const response = await getInformationWithData('/sales/get/header', data);
        const salesOrderList = response.data;

        const getSalesOrder = salesOrderList.find(obj => obj.SalesOrderNo === SONumber)
        if(getSalesOrder){
            return getSalesOrder.Status;
        }
        return 0
    }

    async createSalesOrder(LoadMas90) {
        await this.AsignLineSequence()
        Swal.fire({
            title: 'Are you sure to save this order?',
            text: "",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showCancelButton: true,
            confirmButtonText: 'Yes, please',
            cancelButtonText: 'No, cancel!',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const temporal = JSON.parse(JSON.stringify(this.state.SalesOrder))
                temporal.Detail = this.AsignLineSequence()
                temporal.idCompany = getValueCookie('CompanyId')
                temporal.username = getValueCookie('userName')
                temporal.company = getValueCookie('Company')
                temporal.OrderType = 'SalesOrder'
                temporal.MAS90Status = LoadMas90
                temporal.Packing = this.state.SalesOrder.Packing + ";" + this.state.SalesOrder.WeightOption

                await saveJsonData('/store/json', temporal)

                if (getValueCookie('CompanyId') !== '6' || (getValueCookie('CompanyId') === '6' && !this.state.confirmMargin)) {

                    if ((this.state.SalesOrder.Packing && this.state.SalesOrder.WeightOption) || getValueCookie('CompanyId') === '6') {
                        if (this.state.NotZeroUnitPrice) {
                            const result = await create_Delete_Update_Information('/sales/set/order', temporal)
                            if (result.status.code === 1) {
                                this.setState({ ConfirmSave: this.state.Products.length })
                                // enable next step wizard button
                                this.updateFormData(temporal)
                                await this.SaveAndPrint()
                                await confirmCloseAlert('correct', 'The order was saved successfully!')
                                localStorage.removeItem('SalesOrderSave')
                                // Update ALT SalesOrder
                                if (temporal.Customer.CustomerNo === '0016027'){
                                    // await this.updateCompanyPrices(temporal)
                                    // this.updateMayalandSO(temporal)
                                    this.updateALTSO(temporal)
                                }
                                
                            } else {
                                confirmCloseAlert('incorrect', 'Whoops something is wrong with the system, please call system support.')
                            }
                        } else {
                            Swal.fire({
                                title: 'Some products have Unit Price on Zero.\nPlease Fix that!',
                                text: "",
                                icon: 'warning',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                showCancelButton: true,
                                confirmButtonText: 'OK',
                                cancelButtonText: 'No, cancel!',
                            })
                        }
                    } else {
                        if (!this.state.SalesOrder.Packing) {
                            Swal.fire({
                                title: 'You need select a Type of Packing to Save this Sales Order!',
                                text: "",
                                icon: 'error',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                showCancelButton: false,
                                confirmButtonText: 'Ok'
                            })
                        } else {
                            Swal.fire({
                                title: 'You need select if the order are Weighed or No need to be Weighed',
                                text: "",
                                icon: 'error',
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                showCancelButton: false,
                                confirmButtonText: 'Ok'
                            })
                        }
                    }
                } else {
                    Swal.fire({
                        title: 'Some products have Problem with the Unit Tracking.\nDo you like to continue?',
                        text: "",
                        icon: 'warning',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, please',
                        cancelButtonText: 'No, cancel!',
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            if (this.state.NotZeroUnitPrice) {
                                const result = await create_Delete_Update_Information('/sales/set/order', temporal)
                                if (result.status.code === 1) {
                                    this.setState({ ConfirmSave: this.state.Products.length })
                                    await this.SaveAndPrint()
                                    await confirmCloseAlert('correct', 'The order was saved successfully!')
                                    localStorage.removeItem('SalesOrderSave')
                                    if (getValueCookie('CompanyId') === '6'){
                                        // await this.updateCompanyPrices(temporal)
                                        this.updateMayalandSO(temporal)
                                    }
                                } else {
                                    confirmCloseAlert('incorrect', 'Whoops something is wrong with the system, please call system support.')

                                }
                            } else {
                                Swal.fire({
                                    title: 'Some products have Unit Price on Zero.\nPlease Fix that!',
                                    text: "",
                                    icon: 'warning',
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    showCancelButton: false,
                                    confirmButtonText: 'OK',
                                })
                            }
                        }
                    })
                }
            }
            if((this.state.SalesOrder.Packing && this.state.SalesOrder.WeightOption)){
                this.setState({enableEdit: true})
            }
            if (getValueCookie('CompanyId') === '6'){
                this.setState({enableEdit: true})
            }
        })
    }

    componentDidMount() {
        if (localStorage.getItem('SalesOrderSave')) {
            let infoRec = JSON.parse(localStorage.getItem('SalesOrderSave'));
            if (infoRec) {
                this.setState({ Products: infoRec.Products, SalesOrder: infoRec.SalesOrder })
            }
        }
        window.addEventListener('storage', this.handleStorageChange);
        if (getValueCookie('CompanyId') === '6') {
            this.getItemList();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);
    }


    AutoSave() {
        localStorage.setItem('SalesOrderSave', JSON.stringify(this.state))
    }

    TypeInLetters(type) {
        if (type === 'S') {
            return 'Standard'
        } else {
            return 'Quote'
        }
    }

    handleModalOpen = (modal) => {
        this.setState({ [modal]: true })
    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
    }

    handleStorageChange = async (event) => {
        if (event.key === 'SalesOrderSave') {
            let infoRec = JSON.parse(localStorage.getItem('SalesOrderSave'));
            if (infoRec) {
                if (infoRec.SalesOrder.NoOrder === this.state.SalesOrder.NoOrder) {
                    await this.setState({ Products: infoRec.Products, SalesOrder: infoRec.SalesOrder })
                    await this.refreshInputs()
                }
            }
        }
    }

    validationNewSalesOrder() {
        if (this.state.Products.length !== this.state.ConfirmSave) {
            Swal.fire({
                title: 'Are you sure to Start a new Sales Order, you have a Sales Order open and unsave?',
                icon: 'info',
                showDenyButton: true,
                confirmButtonText: `Yes, I'm sure.`,
                denyButtonText: `Not`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.getNewCorrelativeSalesOrder()
                }
            })
        } else {
            this.getNewCorrelativeSalesOrder()
        }
        this.setState({isNotNewSO: false, newSalesOrder: true})
    }

    onChangeSelects = async (e, id) => {
        const temporal = this.state.SalesOrder
        switch (id) {
            case "Warehouse":
                temporal.Warehouse = e.value
                this.setState({ SalesOrder: temporal })
                this.changePriceLevel(e.value)
                break;
            case "Packing":
                temporal.Packing = e.value
                this.setState({ SalesOrder: temporal })
                break;
            case "Weight":
                temporal.WeightOption = e.value
                this.setState({ SalesOrder: temporal })
                break;
            default:
                break;
        }
    }

    changePriceLevel(id) {
        const temporal = this.state.SalesOrder
        switch (id) {
            case "003":
                temporal.Customer.PriceLevel = '4'
                this.setState({ SalesOrder: temporal })
                break;
            case "000":
                temporal.Customer.PriceLevel = '3'
                this.setState({ SalesOrder: temporal })
                break;

            default:
                break;
        }
    }

    async OnlySaveSO() {
        const temporal = this.state.SalesOrder
        temporal.Detail = this.AsignLineSequence()
        temporal.idCompany = getValueCookie('CompanyId')
        temporal.username = getValueCookie('userName')
        temporal.company = getValueCookie('Company')
        temporal.OrderType = 'SalesOrder'
        await create_Delete_Update_Information('/sales/set/order', temporal)
    }

    async TemporalSaveSystem() {
        const temporal = this.state.SalesOrder
        temporal.Detail = this.AsignLineSequence()
        temporal.idCompany = getValueCookie('CompanyId')
        temporal.username = getValueCookie('userName')
        temporal.company = getValueCookie('Company')
        temporal.OrderType = 'SalesOrder'
        if (temporal.idCompany === '6') {
            await create_Delete_Update_Information('/sales/post/savetemporal', temporal)
        }
    }

    async SaveAndPrint() {
        let button = document.getElementById('SalesOrderPrint')
        if (button) {
            button.click()
        }
    }

    disable() {
        this.setState({ disable: true })
    }

    async updateALTSO(SalesOrderData){
        // Get ALT SO
        const data = {
            OrderNo: SalesOrderData.NoOrder,
            idCompany: 6,
            idcompany: 6,
        }
        
        const result1 = await getInformationWithData('/sales/get/detail', data)
        
        // Update Product List

        // Update ALT SO
    }

    // Wizard functions start

    validateStep(step) {
        const { formData } = this.state
        if(step === 1) return formData.salesOrderNo
        if(step === 2) return formData.status
        return true
    }

    nextStep = () => {
        const { currentStep } = this.state
        // if(this.validateStep(currentStep)) {
            this.setState({currentStep: currentStep + 1})
        // }
        console.log("current step,", this.state.currentStep)
    }

    prevStep() {
        const { currentStep } = this.state
        this.setState({currentStep: currentStep - 1})
    }

    updateFormData(newData) {
        this.setState({
            formData: {...this.state.formData, ...newData}
        })
    }

    returnToFirstStep = () => {
        this.setState({currentStep: 1})
        this.clearSalesOrder()
    }

    // Wizard functions end

    render() {
        const { currentStep } = this.state
        return (
            <div className="container-fluid">
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />
                <div className='text-center my-4'>
                    <h2 className='display-4 fw-bold inventory-title'>Sales Order</h2>
                    <p className='lead text-muted inventory-subtitle'>To start please select a sales order or create a new one</p>
                </div>
                {/* 1. Select sales order and open the order */}
                {currentStep === 1 && (
                    <div>
                        <div className='row pt-1 pb-2'>
                            <div className='col-sm-12'>
                                <div className='row'>
                                    <div className='col-sm-12 pb-4 InputTextBolder text-center'>
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12">
                                                <FinishedSalesOrderList headerName='' nombrePadre="SalesOrderListSO" Padre={this} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-md-6 mb-3'>
                                        <div className='card'>
                                            <div className="card-body">
                                                <div className='row pt-2 pb-2'>
                                                    <div className='col-sm-12'>
                                                        <div className='row'>
                                                            <div className='col-5 InputTextBolder text-end'><p>Order No: </p></div>
                                                            <div className='col-7 textTableSize text-start'>{this.state.SalesOrder.NoOrder}</div>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-12'>
                                                        <div className='row'>
                                                            <div className='col-5 InputTextBolder text-end'><p>Person No: </p></div>
                                                            <div className='col-7 textTableSize text-start'>{this.state.SalesOrder.Customer.SalespersonNo}</div>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-12'>
                                                        <div className='row'>
                                                            <div className='col-5 InputTextBolder text-end'><p>Price Level: </p></div>
                                                            <div className='col-7 textTableSize text-start'>{this.state.SalesOrder.Customer.PriceLevel}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Customer Information */}
                                    <div className='col-sm-12 col-md-6'>
                                        <div className='card'>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className='col-sm-6'>
                                                        <div className='row'>
                                                            <div className='col-sm-12'>
                                                                <div className='row'>
                                                                    <div className='col-6 InputTextBolder text-end'><p>Customer No: </p></div>
                                                                    <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.CustomerNo}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-sm-12'>
                                                                <div className='row'>
                                                                    <div className='col-6 InputTextBolder text-end'><p>Name: </p></div>
                                                                    <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.CustomerName}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-sm-12'>
                                                                <div className='row'>
                                                                    <div className='col-6 InputTextBolder text-end'><p>Address Line: </p></div>
                                                                    <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.AddressLine1}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-sm-12'>
                                                                <div className='row'>
                                                                    <div className='col-6 InputTextBolder text-end'><p>City: </p></div>
                                                                    <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.City}</div>
                                                                </div>
                                                            </div>
                                                            <div hidden={getValueCookie('CompanyId') !== '6'} className='col-sm-12'>
                                                                <div className='row'>
                                                                    <div className='col-6 InputTextBolder text-end'><p>Unique Tracking: </p></div>
                                                                    <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.uniqueTrack}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <div className='row'>
                                                            <div className='col-sm-12'>
                                                                <div className='row'>
                                                                    <div className='col-6 InputTextBolder text-end'><p>Zip Code: </p></div>
                                                                    <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.ZipCode}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-sm-12'>
                                                                <div className='row'>
                                                                    <div className='col-6 InputTextBolder text-end'><p>State: </p></div>
                                                                    <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.State}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-sm-12'>
                                                                <div className='row'>
                                                                    <div className='col-6 InputTextBolder text-end'><p>Telphone No: </p></div>
                                                                    <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.TelephoneNo}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-sm-12'>
                                                                <div className='row'>
                                                                    <div className='col-6 InputTextBolder text-end'><p>Email Address: </p></div>
                                                                    <div className='col-6 textTableSize'>{this.state.SalesOrder.Customer.EmailAddress}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            {/* control sale order final*/}
                            <div className='row pb-2 d-flex'>
                                <div className='col-sm-6 pt-2'>
                                    <div className="input-group input-group-lg flex-nowrap">
                                        <SearchUPC ComponentName={'SalesOrder'} disabled={ this.state.SalesOrder.NoOrder === '' || this.state.enableEdit } Padre={this} priceLevel={this.state.SalesOrder.Customer.PriceLevel} />
                                    </div>
                                </div>
                                <div className='col-sm-6 pt-2 mb-3'>
                                    <div className='row'>
                                        <div className='col-sm-6'>
                                            <Catalogue2 Customer={this.state.SalesOrder.Customer} id='Catalogue2' PriceLevel={this.state.SalesOrder.Customer.PriceLevel} Array={'Products'} nombrePadre={"SalesOrder"} colorButton='purpleButton' Padre={this} disabled={this.state.SalesOrder.NoOrder === '' || this.state.enableEdit } titleButton='Open Catalogue' needPrice={getValueCookie('SalesPerson') === '0010' ? false : true} needCost={getValueCookie('SalesPerson') === '0010' ? true : false} productList={'ProductList'}/>
                                        </div>
                                        <div className='col-sm-6'>
                                            <div className='d-grid gap-2'>
                                                {
                                                    MobileDisp() ?
                                                        <OrderPDF id={"SalesOrderPrint"} colorButton="blackButton" title="Sales Order Print"
                                                            companyLogo={getValueCookie('DocumentsLogo')}
                                                            OrderTitle="Sales Order"
                                                            contactInfo={this.state.companyPrintHeader}
                                                            OrderInfo1={["Order No:", this.state.SalesOrder.NoOrder, "Sales Person:", this.state.SalesOrder.Customer.SalespersonNo,
                                                                "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Date:", DateFormatMAS90(this.state.SalesOrder.Date),
                                                                "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Print By:", getValueCookie('userName'),
                                                                "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                                                "Address:", this.state.SalesOrder.Customer.AddressLine1, "Type:", this.TypeInLetters(this.state.SalesOrder.Type),
                                                                "City:", this.state.SalesOrder.Customer.City, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                                                                "State:", this.state.SalesOrder.Customer.State, "", ""
                                                            ]}
                                                            headerTable={["Item Code", "", "Description", "", "Quantity \n Ordered", "", "Unit \n Price", "", "Total"]}
                                                            bodyTable={this.detailToPrint()}
                                                            headerBodyTable={["itemCode", "", "abbreviatedDesc", "", "quantityOrdered", "dolar", "UnitPrice", "dolar", "totalCost"]}
                                                            bottomInfo={["", "", "", "TOTALS", NumberFormat(this.state.SalesOrder.TotalQuantityOrdered), "", "", "$", NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))]}
                                                            styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaTextoNormalLeft", "ColumnaCantidades", "Dolar", "ColumnaPrecios", "Dolar", "ColumnaPrecios"]}
                                                            comment={""}
                                                            breakpoint={52}
                                                            keysDecimalFormat={["UnitPrice", "totalCost"]}
                                                            disabled={this.state.enableEdit}
                                                        />
                                                        :
                                                        <DownloadOrderPDF id={"SalesOrderPrint"} colorButton="blackButton" title="Sales Order Print"
                                                            companyLogo={getValueCookie('DocumentsLogo')}
                                                            OrderTitle="Sales Order"
                                                            contactInfo={this.state.companyPrintHeader}
                                                            OrderInfo1={["Order No:", this.state.SalesOrder.NoOrder, "Sales Person:", this.state.SalesOrder.Customer.SalespersonNo,
                                                                "Customer No:", this.state.SalesOrder.Customer.CustomerNo, "Date:", DateFormatMAS90(this.state.SalesOrder.Date),
                                                                "Customer Name:", this.state.SalesOrder.Customer.CustomerName, "Print By:", getValueCookie('userName'),
                                                                "Phone:", this.state.SalesOrder.Customer.TelephoneNo, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                                                "Address:", this.state.SalesOrder.Customer.AddressLine1, "Type:", this.TypeInLetters(this.state.SalesOrder.Type),
                                                                "City:", this.state.SalesOrder.Customer.City, "Zip Code:", this.state.SalesOrder.Customer.ZipCode,
                                                                "State:", this.state.SalesOrder.Customer.State, "", ""
                                                            ]}
                                                            docname={this.state.SalesOrder.NoOrder}
                                                            headerTable={["Item Code", "", "Description", "", "Quantity \n Ordered", "", "Unit \n Price", "", "Total"]}
                                                            bodyTable={this.detailToPrint()}
                                                            headerBodyTable={["itemCode", "", "abbreviatedDesc", "", "quantityOrdered", "dolar", "UnitPrice", "dolar", "totalCost"]}
                                                            bottomInfo={["", "", "", "TOTALS", NumberFormat(this.state.SalesOrder.TotalQuantityOrdered), "", "", "$", NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))]}
                                                            styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaTextoNormalLeft", "ColumnaCantidades", "Dolar", "ColumnaPrecios", "Dolar", "ColumnaPrecios"]}
                                                            comment={""}
                                                            breakpoint={52}
                                                            keysDecimalFormat={["UnitPrice", "totalCost"]}
                                                            disabled={this.state.enableEdit}
                                                        />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            {/* 2. Sales Order Detail */}
                            </div>
                            {/* products details start */}
                            <div className='row'>
                                <div className='col-sm-12 tableFixHead'>
                                    <table className='table align-middle table-hover'>
                                        <thead className='table-dark thead'>
                                            <tr>
                                                <th className='text-center'>Item  Code</th>
                                                <th className='text-center'>Description</th>
                                                <th className='text-center'>Quantity</th>
                                                <th className='text-center'>Weight</th>
                                                <th className='text-center'>Total Weight</th>
                                                <th className='text-center'>Unit Price</th>
                                                <th className='text-center'>Total</th>
                                                <th className='text-center'></th>
                                                <th className='text-center'></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.Products.map((item, i) => (
                                                <tr key={i} hidden={item.Visible === 0} className={item.duplicate ? item.duplicate : (item.UnitPrice <= 0 ? 'bg-warning' : '')}>
                                                    <td className='text-center'>{item.itemCode}</td>
                                                    <td className='text-start'>{(item.completeDesc !== "null" && item.completeDesc) ? item.completeDesc : item.abbreviatedDesc}</td>
                                                    <td>
                                                        <div className="input-group  input-group-lg">
                                                            <input disabled={this.state.enableEdit} type="number" id={'quantityOrderedSalesOrder_' + i} min={0} defaultValue={item.quantityOrdered} onChange={(e) => this.onTarget(e, item)} className="form-control text-center inputResize" />
                                                        </div>
                                                    </td>
                                                    <td className='text-center textTableSize text-secondary' >{NumberFormat(pricesFormat(item.ShipWeight)) + ' lbs'}</td>
                                                    <td className='text-center textTableSize text-secondary'> {NumberFormat(pricesFormat(item.quantityOrdered * item.ShipWeight)) + ' lbs'}</td>
                                                    <td >
                                                        <div className="input-group input-group-lg flex-nowrap">
                                                            <span className="input-group-text">$</span>
                                                            <input disabled={this.state.enableEdit} id={'unitPriceSalesOrder_' + i} min={0} step="0.01" defaultValue={Number(item.UnitPrice).toFixed(2)} onChange={(e) => this.onTargetChange(e, item)} value={item.UnitPrice} onBlur={(e) => this.onTarget(e, item)} onFocus={this.checkInputFocus} className="form-control text-end inputResize" />
                                                            {/* <input hidden={getValueCookie('userName') !== 'josue.contreras'} disabled={this.state.enableEdit || (getValueCookie('userName') !== 'josue.contreras' && getValueCookie('TypeUser') !== 1)} id={'unitPriceSalesOrder_' + i} min={0} step="0.01" defaultValue={Number(item.UnitPrice).toFixed(2)} onChange={(e) => this.onTargetChange(e, item)} value={item.UnitPrice} onBlur={(e) => this.onTarget(e, item)} onFocus={this.checkInputFocus} className="form-control text-end inputResize" /> */}
                                                            {/* <td hidden={getValueCookie('userName') === 'josue.contreras'} className='text-start'>{item.UnitPrice}</td> */}
                                                        </div>
                                                    </td>
                                                    <td disabled={this.state.enableEdit} className='text-end textTableSize text-success'> $ {NumberFormat(Number(item.totalCost).toFixed(2))}</td>
                                                    <td>
                                                        <div className="d-grid gap-1">
                                                            <button disabled={this.state.enableEdit} type="button" onClick={() => this.addComentary(item)} className="btn grayButton btn-lg text-wrap"> <AiOutlineComment /> </button>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-grid gap-2">
                                                            <button disabled={this.state.enableEdit} type="button" onClick={() => this.removeProduct(item)} className="btn redButton btn-lg"><FiTrash /></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot className='tfoot'>
                                            <tr className='bg-dark text-white'>
                                                <td></td>
                                                <td className='text-center textTableSize'>Totals</td>
                                                <td className='text-center textTableSize'>{NumberFormat(this.state.SalesOrder.TotalQuantityOrdered)}</td>
                                                <td></td>
                                                <td className='text-center textTableSize'>{NumberFormat(pricesFormat(this.state.SalesOrder.TotalWeight) + ' lbs')} </td>
                                                <td className='text-end textTableSize'>$</td>
                                                <td className='text-end textTableSize'>{NumberFormat(pricesFormat(this.state.SalesOrder.TotalCost))}</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            {/* products details final */}
                            {/* pdf order start */}
                            <div className='row pb-2 d-flex justify-content-center'>
                                <div className='col-10'>
                                    <div className='row d-flex justify-content-center'>
                                        <div className='col-sm-12 col-md-6 mb-3'>
                                            <div className="d-grid gap-2">
                                                <button hidden={this.state.enableEdit} disabled={this.state.Products.length === 0 || this.state.isInputFocused } type="button" onClick={() => this.createSalesOrder(1)} className="btn greenButton btn-lg"><FiSave /> Save Order and Print</button>
                                            </div>
                                        </div>
                                        <div className='col-sm-12 col-md-6 mb-3'>
                                            <div className="d-grid gap-2">
                                                <button disabled={this.state.SalesOrder.NoOrder === ''} onClick={() => this.nextStep()} className="btn blueButton btn-lg">Next</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* pdf order final */}
                        </div>
                    </div>
                )}

                {/* 3. Pickup system and close the order*/}
                {currentStep === 2 && (
                    <div>
                        <SingleOrderPicking selectedOrder={this.state.SalesOrder} returnToFirstStep={this.returnToFirstStep}/>
                        <button className="btn blueButton btn-lg" onClick={() => this.prevStep()}>Prev</button>
                    </div>
                )}
            </div >
        )
    }
}